module.exports = __webpack_public_path__ + "img/8.8b802df7.png";